import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { ApiDemolitionManagementConstants } from "../../constants/api-constants/api-demolition-management.constants";
let DemolitionManagementService = class DemolitionManagementService {
    http;
    constructor(http) {
        this.http = http;
    }
    getApplicationSetPropertiesObservable(applicationId, params) {
        return this.http.post(`${ApiDemolitionManagementConstants.URL}/${applicationId}/${ApiDemolitionManagementConstants.FUNCTION_SET_PROPERTIES}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
DemolitionManagementService = __decorate([
    Injectable({
        providedIn: "root"
    })
], DemolitionManagementService);
export { DemolitionManagementService };
